module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "reward-qr-code-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "reward-qr-code-root",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.hideQRCode($event)
      }
    }
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("打赏")])]), _vm._v(" "), _c('div', {
    staticClass: "nonsense"
  }, [_c('span', [_vm._v("如果觉得我的网站对您有用，请随意打赏。"), _c('br'), _vm._v("您的支持将鼓励我继续创作！")])]), _vm._v(" "), _c('div', {
    staticClass: "qr-code-box"
  }, [_c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [(_vm.payType === 'alipay') ? _c('div', {
    key: _vm.payType,
    staticClass: "qr-code alipay"
  }) : _vm._e(), _vm._v(" "), (_vm.payType === 'wechat') ? _c('div', {
    key: _vm.payType,
    staticClass: "qr-code wechat"
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "toggle-button-box"
  }, [_c('i', {
    staticClass: "iconfont wechat"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-button",
    class: _vm.payType,
    on: {
      "click": _vm.togglePayType
    }
  }, [_c('div', {
    staticClass: "circle"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payType === 'wechat'),
      expression: "payType==='wechat'"
    }],
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payType === 'alipay'),
      expression: "payType==='alipay'"
    }],
    staticClass: "iconfont"
  }, [_vm._v("")])])]), _vm._v(" "), _c('i', {
    staticClass: "iconfont alipay"
  }, [_vm._v("")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14e21e04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward-qr-code/reward-qr-code.vue
// module id = 178
// module chunks = 0